import React, { useEffect, useState } from "react";
import Layout from "../../Layout";
import { Button, FromToDate } from "../../components/Form";
import { Transactiontable } from "../../components/Tables";
// import {
//   sortsDatas,
//   transactionData
// } from "../../components/Datas";
import { BiPlus, BiTime } from "react-icons/bi";
import { MdEditCalendar, MdOutlineCalendarMonth } from "react-icons/md";
import { toast } from "react-hot-toast";
import { BsCalendarMonth } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePayment,
  getAllPaymentStatistics,
  getAllPayments,
  // getPaymentError,
  getPaymentStatistics,
  getPaymentStatus,
  getPayments,
} from "../../redux/features/paymentSlice";
import ConfirmationAlert from "../../components/ConfirmationAlert";
import { pdf } from "@react-pdf/renderer";
import PaymentPdf from "../../pdf/PaymentPdf";
import { saveAs } from "file-saver";
import ThreeColumRow from "../../components/ThreeColumRow";
import TwoColumRow from "../../components/TwoColumRow";
import { specificConfigurationDataUrl } from "../../redux/apiUrl";
// import PaymentsMorlessPdf from "../../pdf/PaymentsMorelessPdf";

// Function to convert number to literal text
const numberToLiteral = (num) => {
  const units = [
    "",
    "uno",
    "dos",
    "tres",
    "cuatro",
    "cinco",
    "seis",
    "siete",
    "ocho",
    "nueve",
  ];
  const teens = [
    "diez",
    "once",
    "doce",
    "trece",
    "catorce",
    "quince",
    "dieciséis",
    "diecisiete",
    "dieciocho",
    "diecinueve",
  ];
  const tens = [
    "",
    "",
    "veinte",
    "treinta",
    "cuarenta",
    "cincuenta",
    "sesenta",
    "setenta",
    "ochenta",
    "noventa",
  ];
  const hundreds = [
    "",
    "cien",
    "doscientos",
    "trescientos",
    "cuatrocientos",
    "quinientos",
    "seiscientos",
    "setecientos",
    "ochocientos",
    "novecientos",
  ];

  if (num === 0) return "cero";

  let literal = "";

  if (num >= 100) {
    literal += hundreds[Math.floor(num / 100)] + " ";
    num %= 100;
  }

  if (num >= 20) {
    literal += tens[Math.floor(num / 10)] + " ";
    num %= 10;
  } else if (num >= 10) {
    literal += teens[num - 10] + " ";
    num = 0;
  }

  if (num > 0) {
    literal += units[num] + " ";
  }

  return literal.trim();
};

function Payments() {
  // const [status, setStatus] = useState(sortsDatas.status[0]);
  // const [method, setMethod] = useState(sortsDatas.method[0]);
  const [filtro, setFiltro] = useState("");
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [dateRange, setDateRange] = useState([
    new Date(new Date().getFullYear(), 0, 1),
    new Date(),
  ]);
  const [startDate, endDate] = dateRange;
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const paymentStatistics = useSelector(getAllPaymentStatistics);
  const paymentStatus = useSelector(getPaymentStatus);
  const payments = useSelector(getAllPayments);

  const [doctorData, setDoctorData] = useState(null);
  // const error = useSelector(getPaymentError);
  useEffect(() => {
    // useeffect para obtener los datos del doctor by Yamil

    const fetchDoctorData = async () => {
      try {
        const response = await fetch(specificConfigurationDataUrl);
        if (!response.ok) {
          throw new Error("Error al obtener los datos del doctor");
        }
        const data = await response.json();
        setDoctorData(data);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchDoctorData();
  }, []);
  useEffect(() => {
    dispatch(getPaymentStatistics());
    dispatch(getPayments());
    setFilteredPayments(payments);
  }, [payments?.length, paymentStatistics?.total]);

  const boxes = [
    {
      id: 1,
      title: "Pagos del día",
      value: "day",
      color: ["bg-subMain", "text-subMain"],
      icon: BiTime,
    },
    {
      id: 2,
      title: "Pagos del mes actual",
      value: "month",
      color: ["bg-orange-500", "text-orange-500"],
      icon: BsCalendarMonth,
    },
    {
      id: 3,
      title: "Pagos del año actual.",
      value: "year",
      color: ["bg-green-500", "text-green-500"],
      icon: MdOutlineCalendarMonth,
    },
    {
      id: 4,
      title: "Pagos Total",
      value: "total",
      color: ["bg-blue-500", "text-blue-500"],
      icon: MdEditCalendar,
    },
  ];

  const editPayment = (id) => {
    navigate(`/payments/edit/${id}`);
  };
  // preview
  const previewPayment = (id) => {
    navigate(`/payments/preview/${id}`);
  };

  const bajaPayment = async (id) => {
    ConfirmationAlert({
      title: "Dar baja pago",
      text: "Esta seguro de dar de baja el registro de pago?",
      onAccept: async () => {
        const res = await dispatch(deletePayment(id));
        if (res.error) {
          toast.error(res.error.message, { duration: 5000 });
        } else {
          toast.success("Pago dado de baja con exito!", { duration: 5000 });
          navigate(0);
        }
      },
    });
  };

  const printPayment = async (id) => {
    ConfirmationAlert({
      title: "Imprimir recibo",
      text: "Esta seguro de imprimir recibo de pago?",
      onAccept: async () => {
        let paymentId = filteredPayments.find((payment) => payment.id === id);
        const blob = await pdf(
          <PaymentPdf
            data={{
              nombre: `${paymentId?.patient.persona.nombre} ${paymentId?.patient.persona.apellidos}`,
              telefono: paymentId?.patient.persona.telf1,
              fecha: new Date(paymentId?.created_at).toLocaleDateString(
                "en-GB"
              ),
              monto: paymentId.monto,
              saldo: paymentId.saldo,
              monto_literal: `${numberToLiteral(
                paymentId.monto
              )}  00/100 Bolivianos.`,
              metodo: paymentId.metodo,
              motivo: `${paymentId.motivo} - ${paymentId.observaciones} `,
              doctor: doctorData,
            }}
          />
        ).toBlob();
        saveAs(
          blob,
          `Pago-${paymentId.id}-${new Date().toLocaleDateString("en-GB")}.pdf`
        );
      },
    });
  };

  const handleFilter = (e) => {
    setFiltro(e.target.value.toLowerCase());
    if (e.target.value === "") {
      setFilteredPayments(payments);
    } else {
      setFilteredPayments(
        payments.filter(
          (payment) =>
            payment?.patient?.persona?.nombre?.toLowerCase().includes(filtro) ||
            payment?.patient?.persona?.apellidos?.toLowerCase().includes(filtro)
        )
      );
    }
  };

  return (
    <Layout>
      <Link
        to="/payments/create"
        className="w-16 animate-bounce h-16 border border-border z-50 bg-subMain text-white rounded-full flex-colo fixed bottom-8 right-12 button-fb"
      >
        <BiPlus className="text-2xl" />
      </Link>

      <h1 className="text-xl font-semibold">Pagos</h1>
      {/* boxes */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-8">
        {boxes.map((box, index) => (
          <div
            key={box.id}
            className="bg-white flex-btn gap-4 rounded-xl border-[1px] border-border p-5"
          >
            <div className="w-3/4">
              <h2 className="text-sm font-medium">{box.title}</h2>
              <h2 className="text-xl my-6 font-medium">
                {paymentStatistics !== null
                  ? paymentStatistics[Object.keys(paymentStatistics)[index]] +
                    " bs."
                  : ""}
              </h2>
            </div>
            <div
              className={`w-10 h-10 flex-colo rounded-md text-white text-md ${box.color[0]}`}
            >
              <box.icon />
            </div>
          </div>
        ))}
      </div>
      {/* datas */}
      <div
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="10"
        data-aos-offset="200"
        className="bg-white my-8 rounded-xl border-[1px] border-border p-5"
      >
        <TwoColumRow>
          <input
            type="text"
            value={filtro}
            onChange={(e) => handleFilter(e)}
            placeholder="Filtrar por Nombre o Apellidos"
            className="h-14 text-sm text-main rounded-md bg-dry border border-border px-4"
          />

          <FromToDate
            startDate={startDate}
            endDate={endDate}
            bg="bg-dry"
            onChange={(update) => {
              setDateRange(update);
              setFilteredPayments(
                payments.filter(
                  (payment) =>
                    new Date(payment.created_at) >=
                      update[0]?.setHours(0, 0, 0, 0) &&
                    new Date(payment.created_at) <=
                      update[1]?.setHours(23, 59, 59, 999)
                )
              );
            }}
          />

          {/* <Button
            label="Imprimir pagos morosos"
            onClick={
              async () => {
                const blob = await pdf(
                  <PaymentsMorlessPdf
                    data={payments}
                  />
                ).toBlob();
                saveAs(
                  blob,
                  `Morosos-${new Date().toLocaleDateString("en-GB")}.pdf`
                );
              }
            }
          /> */}
        </TwoColumRow>
        <div className="mt-8 w-full overflow-x-scroll">
          <Transactiontable
            status={paymentStatus}
            data={filteredPayments}
            action={true}
            functions={{
              edit: editPayment,
              preview: previewPayment,
              delete: bajaPayment,
              print: printPayment,
            }}
          />
        </div>
      </div>
    </Layout>
  );
}

export default Payments;
